import React from "react";
import { Form } from "antd";
import CustomModal from "components/Common/CustomModal";
import { useTranslation } from "react-i18next";
import CommonSelect from "components/Common/CommonSelect";

export interface TeacherOption {
  value: string | number;
  label: string;
}

interface AssignTeacherToClassModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (teacherId: string) => Promise<void> | void;
  teacherOptions: TeacherOption[];
  selectedClassSubject?: any; // optional, just for title context
}

const AssignTeacherToClassModal: React.FC<AssignTeacherToClassModalProps> = ({
  open,
  onClose,
  onSave,
  teacherOptions,
  selectedClassSubject,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      const { teacherId } = await form.validateFields();
      await onSave(teacherId);
      onClose();
    } catch (error) {
      console.error("Error validating form:", error);
    }
  };

  React.useEffect(() => {
    if (open) form.resetFields();
    form.setFieldsValue({
      teacherId: selectedClassSubject?.teacher?.id,
    });
  }, [open, form]);

  return (
    <CustomModal
      isOpen={open}
      onClose={onClose}
      title={t("assign_teacher")}
      onSave={handleOk}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="teacherId"
          label={t("teacher")}
          rules={[{ required: true, message: t("validation.teacher_required") }]}
        >
          <CommonSelect options={teacherOptions as any} isSearchable minSearchChars={2} onChange={(value) => form.setFieldValue("teacherId", value?.value)}  defaultValue={teacherOptions.find((option) => option.value === selectedClassSubject?.teacher?.id) as any || undefined}/>
        </Form.Item>
      </Form>
    </CustomModal>
  );
};

export default AssignTeacherToClassModal;
